// extracted by mini-css-extract-plugin
module.exports = {"suggestedAddressHighlight":"zI","wrapper":"AI","fullName":"BI"};